import React, { useState, useEffect } from "react";
import apiClient from '../../../services/apiClient';
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import "../All-Events/AllEvents.css";
import SendToCustomerFormModal from "../All-Events/SendToCustomerFormModal/SendToCustomerFormModal";
import SendToCustomerInfoModal from "../All-Events/SendToCustomerFormModal/SendToCustomerInfoModal";
import ViewProposalInfoModal from "../All-Events/SendToCustomerFormModal/ViewProposalInfoModal";
import ViewQuestionInfoModal from "../All-Events/SendToCustomerFormModal/ViewQuestionInfoModal";
import ViewContractInfoModal from "../All-Events/SendToCustomerFormModal/ViewContractInfoModal";
import ViewInvoiceInfoModal from "../All-Events/SendToCustomerFormModal/ViewInvoiceInfoModal";
import { EventOverview } from "./EventOverview/EventOverview";
import { EventProducts } from "./EventProducts/EventProducts";
import { Payments } from "./Payments/Payments";
import { useNavigate } from "react-router-dom";

export default function CustomerEvent() {
  let { state } = useLocation();
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const { event } = state || {};

  const { eventid } = useParams();
  const [EventData, setEventData] = useState({});
  const [sharedContactsData, setsharedContactsData] = useState({});
  const [sharedProposalData, setsharedProposalData] = useState({});
  const [sharedInvoiceData, setsharedInvoiceData] = useState({});
  const [sharedQuestionnairesData, setsharedQuestionnairesData] = useState({});

  const [sharedAll, setsharedAll] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  const [userId, setUserId] = useState(null);
  const [selectedid, setSelectedid] = useState(null);
  const [selectedtype, setSelectedtype] = useState(null);

  const [isModalVisible, setIsModalVisible] = useState(false);

  const openModal = () => setIsModalVisible(true);
  const closeModal = () => setIsModalVisible(false);

    const [subscription, setSubscription] = useState(null);
   const [loadingSubscription, setLoadingSubscription] = useState(true);

  useEffect(() => {
    // Check if user data exists in localStorage
    const udata = localStorage.getItem("user");
    if (!udata) {
      // Redirect to login page if user data does not exist
      navigate("/sign-in");
      return;
    }
    const user_data = JSON.parse(udata);
    setUserId(user_data.user.id);
  }, [navigate]);

  // Single useEffect to fetch data - removed duplicate
  useEffect(() => {
    if (eventid) {
      fetchEventDetails();
      fetchallshard();
    }
  }, [eventid]);

  const fetchEventDetails = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get(
        `/fetchevent/${eventid}`
      );
      if (response.data.success === true) {
        setEventData(response.data.events);
        // const eventIdpay = eventid;
        //localStorage.setItem('event_pay_id', eventIdpay);
        if (
          response.data.sharedContacts !== null &&
          response.data.sharedContacts !== undefined
        ) {
          setsharedContactsData(response.data.sharedContacts);
        }
        if (
          response.data.sharedProposal !== null &&
          response.data.sharedProposal !== undefined
        ) {
          setsharedProposalData(response.data.sharedProposal);
        }
        if (
          response.data.sharedInvoice !== null &&
          response.data.sharedInvoice !== undefined
        ) {
          setsharedInvoiceData(response.data.sharedInvoice);
        }
        if (
          response.data.sharedQuestionnaires !== null &&
          response.data.sharedQuestionnaires !== undefined
        ) {
          setsharedQuestionnairesData(response.data.sharedQuestionnaires);
        }
      }
    } catch (error) {
      console.error("Error fetching event details:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchallshard = async () => {
    try {
      const response_all_shared = await apiClient.get(
        `/fetchallshared/${eventid}`
      );


      setsharedAll(response_all_shared.data);
    } catch (error) {
      console.error("Error fetching event details:", error);
    }
  };

  // Removed duplicate useEffect - now handled in single useEffect above

  const handleUpdate = () => {
    // Re-fetch event details to reflect updates
    fetchEventDetails();
  };

  const selectinfo = (id, type) => {
    const closeModalBtn = document.getElementById("clobtn1");
    setSelectedid(id);
    setSelectedtype(type);
    //alert(id);
    closeModalBtn.click();
    if (isModalVisible) {
      closeModal();
    } else {
      openModal();
    }
  };

  useEffect(() => {
    closeModal();
  }, [isModalVisible]);

    const getToken = () => {
  const data = localStorage.getItem("user");
  if (!data) return null;
  return JSON.parse(data).access_token;
};

useEffect(() => {
  const fetchSubscription = async () => {
    try {
      const token = getToken();
      if (!token) return;

      const res = await apiClient.get(
        `/subscription/status`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSubscription(res.data);
    } catch (err) {
      console.error("Subscription fetch failed", err);
    } finally {
      setLoadingSubscription(false);
    }
  };

  fetchSubscription();
}, []);


const handleSubscribe = async () => {
  try {
    const token = getToken();
    if (!token) return;

    const res = await apiClient.post(
      `/billing/checkout`, // ✅ correct route
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    window.location.href = res.data.url;
  } catch (err) {
    console.error("Checkout error", err);
  }
};


  const isEmptycontract = Object.keys(sharedContactsData).length === 0;
  const isEmptyproposal = Object.keys(sharedProposalData).length === 0;
  const isEmptyinvoice = Object.keys(sharedInvoiceData).length === 0;
  const isEmptyquestion = Object.keys(sharedQuestionnairesData).length === 0;

  // Loading state
  if (loading) {
    return (
      <div className="container-fluid p-lg-5 p-md-5 p-2">
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
          <div className="text-center">
            <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }} role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3 text-muted">Loading customer info...</p>
          </div>
        </div>
      </div>
    );
  }



const ALLOWED = ["active", "trialing"];
const SOFT_WARN = ["past_due", "incomplete"];
const HARD_BLOCK = ["canceled", "unpaid", "expired"];



  return (
    <>
      <SendToCustomerFormModal fun={selectinfo} eventid={eventid} />

      <SendToCustomerInfoModal
        showModal={isModalVisible}
        closeModal={closeModal}
        type={selectedtype}
        id={selectedid}
      />
      {sharedAll.map((item) => (
        <>
          {item.source == "proposal" && (
            <ViewProposalInfoModal
              showModal={isModalVisible}
              closeModal={closeModal}
              code={item.code}
              type={item.source}
              id={item.id}
            />
          )}

          {item.source == "questionnaire" && (
            <ViewQuestionInfoModal
              user={item.user}
              showModal={isModalVisible}
              closeModal={closeModal}
              code={item.code}
              type={item.source}
              data={item}
              id={item.id}
            />
          )}

          {item.source == "contract" && (
            <ViewContractInfoModal
              user={item.user}
              showModal={isModalVisible}
              closeModal={closeModal}
              code={item.code}
              type={item.source}
              data={item}
              id={item.id}
            />
          )}

          {item.source == "invoice" && (
            <ViewInvoiceInfoModal
              user={item.user}
              showModal={isModalVisible}
              closeModal={closeModal}
              code={item.code}
              type={item.source}
              data={item}
              id={item.id}
              eventDate={EventData.date}
            />
          )}
        </>
      ))}

      <div className="container-fluid p-lg-5 p-md-5 p-2 customerEvent">
        <div className="row">
          <div className="col-lg-10 col-md-10 col-12 mx-auto">
            <div className="top_title d-flex align-items-start mb-5">
              <div>
                <h4>{EventData.name}</h4>
                <p className="mb-0 mt-3">{EventData.address}..</p>
              </div>

              <button
                className=" but-primary border-bottom-5 mx-auto"
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
              >
                Send Customer
              </button>
            </div>
            <nav>
              <div className="nav nav-tabs" id="nav-tab" role="tablist">
                <button
                  className="nav-link active fs-5"
                  id="nav-home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-home"
                  type="button"
                  role="tab"
                  aria-controls="nav-home"
                  aria-selected="true"
                >
                  Event Overview
                </button>
                <button
                  className="nav-link fs-5"
                  id="nav-profile-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-profile"
                  type="button"
                  role="tab"
                  aria-controls="nav-profile"
                  aria-selected="false"
                >
                  Payment
                </button>
                <button
                  className="nav-link fs-5 border-bottom-5"
                  id="nav-contact-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-contact"
                  type="button"
                  role="tab"
                  aria-controls="nav-contact"
                  aria-selected="false"
                >
                  Event Products
                </button>
                <button
                  className="nav-link fs-5 border-bottom-5"
                  id="nav-contact-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-contact1"
                  type="button"
                  role="tab"
                  aria-controls="nav-contact"
                  aria-selected="false"
                >
                  Files
                </button>
              </div>
            </nav>
            <div className="tab-content mt-5" id="nav-tabContent">
              <div
                className="tab-pane fade  show active"
                id="nav-home"
                role="tabpanel"
                aria-labelledby="nav-home-tab"
              >
                <EventOverview onUpdate={handleUpdate} />
              </div>
              <div
                className="tab-pane fade"
                id="nav-profile"
                role="tabpanel"
                aria-labelledby="nav-profile-tab"
              >
                <Payments eventId={eventid} />
              </div>
              <div
                className="tab-pane fade"
                id="nav-contact"
                role="tabpanel"
                aria-labelledby="nav-contact-tab"
              >
                <EventProducts />
              </div>
              <div
                className="tab-pane fade"
                id="nav-contact1"
                role="tabpanel"
                aria-labelledby="nav-contact-tab"
              >
                <div className="container-fluid py-5 px-2 bg-white">
                  <div className="row">
                    <div className="col-lg-10 col-md-10  col-12 mx-auto my-5">
                      {event?.recentActivity === "NOT SENT" ? (
                        <div className="files_content">
                          <div className="image">
                            <img src="/img/files_image.png" alt="FILES" />
                          </div>

                          <div className="mt-5 text-center ">
                            <h4>Any Files Sent to Customer Will be Here</h4>
                            <p className="">
                              Keep track of your event files that was used for
                              this event, All files such contracts, invoices,
                              proposals that was sent for This event will be
                              seen here
                            </p>
                          </div>
                        </div>
                      ) : (
                        <div>
                          {sharedAll.map((item) => (
                            <div className="summary-box">
                              <div className="summary-title">
                                ACTION SUMMARY
                              </div>

                              <div className="contract-card">
                                {/* Left side */}
                                <div className="left-side">
                                  <div className="doc-icon">📄</div>
                                  <div className="contract-info">
                                    <div className="contract-title">
                                      {item.source}
                                      <span>*</span>
                                    </div>

                                    {(item.source == "contract" ||
                                      item.source == "proposal" ||
                                      item.source == "invoice") && (
                                      <>
                                        <div className="person">
                                          <div className="avatar">RE</div>
                                          <span>
                                            {item.username}(you){" "}
                                            <strong>*</strong>
                                          </span>
                                        </div>

                                        <div className="person">
                                          <div className="avatar">RT</div>
                                          <span>
                                            {item.customer_name}{" "}
                                            <strong>*</strong>
                                          </span>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>

                                {/* Right side */}
                                <div className="right-side">
                                  <div>&nbsp;</div>
                                  <div>&nbsp;</div>

                                  {item.source == "contract" ||
                                  item.source == "proposal" ? (
                                    <>
                                      {item.usersignature != null ? (
                                        <>
                                          <div
                                            className="signaturemainfile"
                                            style={{ textAlign: "right" }}
                                          >
                                            {item.usersignature}
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          {" "}
                                          <span className="not-signed">
                                            Not Signed
                                          </span>{" "}
                                        </>
                                      )}

                                      {item.signed != null ? (
                                        <>
                                          <div
                                            className="signaturemainfile"
                                            style={{ textAlign: "right" }}
                                          >
                                            {item.signed}
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          {" "}
                                          <span className="not-signed">
                                            Not Signed
                                          </span>{" "}
                                        </>
                                      )}
                                    </>
                                  ) : (
                                    <></>
                                  )}

                                  {item.source == "proposal" && (
                                    <>
                                      <button
                                        className="view-btn"
                                        data-bs-toggle="modal"
                                        data-bs-target={`#exampleModal${item.id}${item.code}`}
                                      >
                                        {" "}
                                        View {item.source}
                                      </button>
                                    </>
                                  )}

                                  {item.source == "questionnaire" && (
                                    <>
                                      <button
                                        className="view-btn"
                                        data-bs-toggle="modal"
                                        data-bs-target={`#exampleModalq${item.id}${item.code}`}
                                      >
                                        {" "}
                                        View {item.source}
                                      </button>
                                    </>
                                  )}

                                  {item.source == "contract" && (
                                    <>
                                      <button
                                        className="view-btn"
                                        data-bs-toggle="modal"
                                        data-bs-target={`#exampleModalc${item.id}${item.code}`}
                                      >
                                        {" "}
                                        View {item.source}
                                      </button>
                                    </>
                                  )}

                                  {item.source == "invoice" && (
                                    <>
                                      <button
                                        className="view-btn"
                                        data-bs-toggle="modal"
                                        data-bs-target={`#exampleModali${item.id}${item.code}`}
                                      >
                                        {" "}
                                        View {item.source}
                                      </button>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {!loadingSubscription &&
  subscription &&
  (
    HARD_BLOCK.includes(subscription.status) ||
    (
      subscription.status === "trialing" &&
      new Date(subscription.current_period_end) < new Date()
    )
  ) && (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.6)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        className="bg-white rounded p-4 shadow"
        style={{
          maxWidth: "420px",
          width: "90%",
          textAlign: "center",
        }}
      >
        <h4 className="mb-3">Subscription Required</h4>

        <p className="text-muted">
          Your subscription is inactive.
          Please add a payment method to continue.
        </p>

        <button
          className="btn btn-danger w-100 mt-3"
          onClick={handleSubscribe}
        >
          Add Payment Method
        </button>
      </div>
    </div>
)}


    </>
  );
}
